"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createDataReducer = void 0;

var _actions = require("./actions");

var _getSuccessState = _interopRequireDefault(require("./getSuccessState"));

var _getDeletedPatchByActivityTag = _interopRequireDefault(require("./getDeletedPatchByActivityTag"));

var _reinitializeState = _interopRequireDefault(require("./reinitializeState"));

var _getNormalizedActivatedState = _interopRequireDefault(require("../../normalize/getNormalizedActivatedState"));

var _getNormalizedDeletedState = _interopRequireDefault(require("../../normalize/getNormalizedDeletedState"));

var _getNormalizedMergedState = _interopRequireDefault(require("../../normalize/getNormalizedMergedState"));

var _utils = require("../../normalize/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var createDataReducer = function createDataReducer() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extraConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var wrappedReducer = function wrappedReducer(state, action) {
    var keepFromActivity = (action.config || {}).keepFromActivity || extraConfig.keepFromActivity || _utils.getDefaultActivityFrom;

    if (action.type === _actions.ACTIVATE_DATA) {
      var _getNormalizedMergedS = (0, _getNormalizedMergedState["default"])(state, {
        __activities__: action.activities
      }, {
        getDatumIdKey: function getDatumIdKey() {
          return 'localIdentifier';
        },
        getDatumIdValue: function getDatumIdValue(activity) {
          return activity.id || "".concat(activity.entityIdentifier, "/").concat(activity.dateCreated);
        },
        isMergingDatum: true
      }),
          nextActivities = _getNormalizedMergedS.__activities__;

      return nextActivities.length ? _objectSpread(_objectSpread({}, state), {}, {
        __activities__: nextActivities
      }) : state;
    }

    if (action.type === _actions.ASSIGN_DATA) {
      return Object.keys(action.patch || {}).length ? _objectSpread(_objectSpread({}, state), action.patch) : state;
    }

    if (action.type === _actions.DELETE_DATA) {
      var patch = action.patch || state;

      if (action.config.tags) {
        patch = (0, _getDeletedPatchByActivityTag["default"])(patch, action.config.tags);
      }

      var deleteState = (0, _getNormalizedDeletedState["default"])(state, patch, action.config);
      return Object.keys(deleteState).length ? _objectSpread(_objectSpread({}, state), deleteState) : state;
    }

    if (action.type === _actions.MERGE_DATA) {
      var mergeState = (0, _getNormalizedMergedState["default"])(state, action.patch, action.config);
      return Object.keys(mergeState).length ? _objectSpread(_objectSpread({}, state), mergeState) : state;
    }

    if (action.type === _actions.REINITIALIZE_DATA) {
      return (0, _reinitializeState["default"])(state, initialState, action.config);
    }

    if (action.type === 'persist/REHYDRATE' && typeof action.payload !== 'undefined' && typeof action.payload.__activities__ !== 'undefined') {
      return (0, _getNormalizedActivatedState["default"])(state, action.payload, {
        keepFromActivity: keepFromActivity
      });
    }

    if (/SUCCESS_DATA_(DELETE|GET|POST|PUT|PATCH)_(.*)/.test(action.type)) {
      var successState = (0, _getSuccessState["default"])(state, action);
      return Object.keys(successState).length ? _objectSpread(_objectSpread({}, state), successState) : state;
    }

    return state;
  };

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var keepFromActivity = (action.config || {}).keepFromActivity || extraConfig.keepFromActivity || _utils.getDefaultActivityFrom;
    var nextState = wrappedReducer(state, action);

    if (state.__activities__ !== nextState.__activities__ || nextState.__activities__ && nextState.__activities__.some(function (activity) {
      return activity.localIdentifier;
    })) {
      return (0, _getNormalizedActivatedState["default"])(nextState, {
        __activities__: nextState.__activities__
      }, {
        keepFromActivity: keepFromActivity
      });
    }

    return nextState;
  };

  return reducer;
};

exports.createDataReducer = createDataReducer;
var _default = createDataReducer;
exports["default"] = _default;